export default function reloadPageWithUrlParams(dispatch, action, query) {
  dispatch({
    type: action,
    payload: {
      query,
    },
  })
}
